import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import Button from '../../../../button';
import ApiDatabase from '../../../../../server';
import { useState } from 'react';
import { toast } from 'react-toastify';

const ModalInvoiceDelete = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const token = localStorage.getItem('xsrfToken');

  const invoices = modalData?.invoices || [];
  const isBulk = invoices.length > 1;

  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = () => {
    setIsLoading(true);
    ApiDatabase.deleteInvoices(
      {
        token,
        invoice_numbers: invoices.map((inv) => inv.invoice_number),
      },
      (data) => {
        setIsLoading(false);
        toast.success(
          `${data.successes?.length || 0} facture(s) supprimée(s).`
        );
        setModalDataReturn({
          action: 'invoices_deleted',
          invoice_numbers: (data.successes || []).map((s) => s.invoice_number),
        });
        toggle();
      },
      (err) => {
        setIsLoading(false);
        toast.error(err.response?.data?.error || 'Erreur');
      }
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    try {
      const [y, m, d] = dateStr.slice(0, 10).split('-');
      return `${d}/${m}/${y}`;
    } catch {
      return dateStr;
    }
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Supprimer {isBulk ? `${invoices.length} factures` : 'une facture'}
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-3 text-sm">
          <p className="text-red-600 font-medium">
            Cette action est irréversible. Les fichiers seront supprimés de S3
            et de la base de données.
          </p>
          {isBulk ? (
            <div className="max-h-[300px] overflow-y-auto border rounded">
              <table className="w-full text-sm">
                <thead className="bg-gray-50 sticky top-0">
                  <tr>
                    <th className="p-2 text-left">N° Facture</th>
                    <th className="p-2 text-left">Entreprise</th>
                    <th className="p-2 text-right">Montant</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices.map((inv) => (
                    <tr
                      key={inv.invoice_number}
                      className="border-t border-gray-100"
                    >
                      <td className="p-2">{inv.invoice_number}</td>
                      <td className="p-2">{inv.company_name}</td>
                      <td className="p-2 text-right">
                        {inv.amount ? `${Number(inv.amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €` : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            invoices[0] && (
              <div className="flex flex-col gap-1">
                <div>
                  <strong>N° Facture :</strong> {invoices[0].invoice_number}
                </div>
                <div>
                  <strong>Entreprise :</strong> {invoices[0].company_name}
                </div>
                <div>
                  <strong>Date :</strong> {formatDate(invoices[0].date_facture)}
                </div>
                <div>
                  <strong>Montant :</strong>{' '}
                  {invoices[0].amount
                    ? `${Number(invoices[0].amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
                    : '-'}
                </div>
              </div>
            )
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="flex gap-2">
          <Button onClick={toggle} size="LG" color="SECONDARY">
            Annuler
          </Button>
          <Button
            onClick={handleConfirm}
            size="LG"
            color="WARNING"
            disabled={isLoading}
          >
            {isLoading ? 'Suppression...' : 'Confirmer la suppression'}
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};

export default ModalInvoiceDelete;
